<h2 mat-dialog-title>{{ 'INVENTORY_UI.EDIT_RETAIL_BILLING_FREQUENCY_DIALOG.TITLE' | translate }}</h2>
<mat-dialog-content>
  <form [formGroup]="form">
    <div class="item-info-pricing-container">
      <div class="item-name-icon-container">
        <inventory-ui-item-label
          [item]="{
            itemId: data.itemId,
            name: data.name,
            iconUrl: data.iconUrl,
            editionName: data.editionName,
          }"
          [showItemId]="false"
          [showEditionName]="true"
        />
      </div>
      <billing-ui-simple-price-display
        class="center-text-vertically"
        [price]="data.revenueComponent.revenue"
        [frequency]="this.billingFrequency | revenuePeriodToGalaxyFrequency"
      />
    </div>
    <glxy-form-field>
      <glxy-label>{{
        'INVENTORY_UI.EDIT_RETAIL_BILLING_FREQUENCY_DIALOG.RETAIL_BILLING_FREQUENCY' | translate
      }}</glxy-label>
      <mat-select formControlName="frequency" [disabled]="data.viewOnly">
        <mat-option *ngFor="let frequency of frequencyOptions" [value]="frequency.value">
          {{ frequency.label | translate }}
        </mat-option>
      </mat-select>
    </glxy-form-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions class="dialog-buttons">
  <button mat-stroked-button mat-dialog-close>
    {{ 'INVENTORY_UI.COMMON.ACTIONS.CANCEL' | translate }}
  </button>
  <button mat-flat-button color="primary" (click)="save()" [disabled]="!form.valid">
    {{ 'INVENTORY_UI.COMMON.ACTIONS.SAVE' | translate }}
  </button>
</mat-dialog-actions>
